import { FONT_WEIGHT } from '../../../foundations/typography';
import { TableCellVariantType } from '../variants';
export const getHeaderCellStyles = (FOUNDATIONS, FONT, FONT_FAMILY) => {
    return {
        [TableCellVariantType.HEADER_CELL]: {
            container: {
                display: 'table-cell',
                transition: 'box-shadow 200ms',
                padding: FOUNDATIONS.spacing_150,
                background_color: FOUNDATIONS.color_comp_tableslist_tablecells_bg,
                font_family: '"Outfit Font", sans-serif',
                color: FOUNDATIONS.color_neutral_font_50,
                font_weight: FONT_WEIGHT.font_bold,
                font_size: FONT.font_paragraph_250.DESKTOP.font_size,
                line_height: FONT.font_paragraph_250.DESKTOP.line_height,
                vertical_align: 'top',
                // When display flex in row groups
                align_items: 'start',
            },
        },
    };
};
//# sourceMappingURL=headerCell.js.map